import ArticleTemplate from '@/components/feature/ArticleTemplate';
import { allArticles } from '@/mocks/articles';

const article = allArticles.find((a) => a.slug === 'vigorbuy-spreadsheet-review')!;

export default function ArticleReviewPage() {
  return <ArticleTemplate article={article} />;
}